import React, { useContext } from 'react';

import { CompanyContext } from 'common/containers/CompanyContainer';

import type { CompanyPostStatus } from 'common/api/endpoints/companies';
import type { ApplyPostStatus as ApplyPostStatusType, Filter } from 'common/automations/constants';
import type { Option } from 'common/ui/common/select/SelectCommon';
import { Select } from 'common/uiV3/Select';

interface Props {
  filters: Filter[];
  properties: ApplyPostStatusType['properties'];
  onChange: (properties?: ApplyPostStatusType['properties']) => void;
}

const ApplyPostStatus = ({ filters, ...props }: Props) => {
  const company = useContext(CompanyContext);
  const { properties, onChange } = props;

  if (company.statuses.length === 0) {
    return null;
  }

  const options: Option[] = company.statuses.map((status: CompanyPostStatus) => ({
    label: status.name,
    value: status._id,
  }));
  const selectedOption = options.find((option) => option.value === properties.statusID);

  if (!selectedOption) {
    onChange({ statusID: company.statuses[0]._id });
    return null;
  }

  return (
    <div className="grid2">
      <Select
        onValueChange={(option) => option && onChange({ statusID: option })}
        options={options}
        placeholder="Select a tag"
        value={selectedOption?.value}
        fullWidth
      />
    </div>
  );
};

export default ApplyPostStatus;
